export type AppLocale = 'es' | 'en'

export const SUPPORTED_LOCALES: readonly AppLocale[] = ['es', 'en']

export const DEFAULT_LOCALE: AppLocale = 'en'

export const UI_LOCALE_STORAGE_KEY = 'controlla.ui.locale'

export const normalizeAppLocale = (value: unknown): AppLocale | null => {
  if (value === 'es' || value === 'en') {
    return value
  }

  return null
}

export const readStoredUserLocale = (): AppLocale | null => {
  if (typeof localStorage === 'undefined') {
    return null
  }

  return normalizeAppLocale(localStorage.getItem(UI_LOCALE_STORAGE_KEY))
}

export const writeStoredUserLocale = (locale: AppLocale | null) => {
  if (typeof localStorage === 'undefined') {
    return
  }

  if (locale) {
    localStorage.setItem(UI_LOCALE_STORAGE_KEY, locale)
    return
  }

  localStorage.removeItem(UI_LOCALE_STORAGE_KEY)
}

const getNavigatorLanguages = (): string[] => {
  if (typeof navigator === 'undefined') {
    return [DEFAULT_LOCALE]
  }

  if (navigator.languages?.length) {
    return [...navigator.languages]
  }

  if (navigator.language) {
    return [navigator.language]
  }

  return [DEFAULT_LOCALE]
}

/**
 * Resuelve el locale de la app a partir de las preferencias del navegador/dispositivo.
 * Solo admite `es` y `en`; cualquier otro idioma cae en inglés.
 */
export const resolveDeviceLocale = (
  languageTags: readonly string[] = getNavigatorLanguages(),
): AppLocale => {
  for (const tag of languageTags) {
    const base = tag.toLowerCase().split('-')[0]

    if (base === 'es') {
      return 'es'
    }

    if (base === 'en') {
      return 'en'
    }
  }

  return DEFAULT_LOCALE
}
